<template>
  <div class="">
      <Cart no-cart="yes" title="Checkout"></Cart>
      <div v-bind:class="alertObject" v-if="numInCart && message.length > 0"> {{ message }} </div>
      <div class="container-fluid">
        <div v-if="numInCart > 0" class="row">
          <input type="text" class="form-control col-12 m-b-15" placeholder="Full Name" v-model="newUser.name">
          <input type="text" class="form-control col-12 m-b-15" placeholder="Email" v-model="newUser.email">
          <div class="label label-primary col-12">Shipping Address:</div>
          <input type="text" class="form-control col-4 m-b-15" placeholder="Street/Apt" v-model="newUser.street">
          <input type="text" class="form-control col-4 m-b-15" placeholder="City" v-model="newUser.city">
          <input type="text" class="form-control col-4 m-b-15" placeholder="State" v-model="newUser.state">
          <!-- <input type="text" class="form-control m-b-15" placeholder="Zip Code" v-model="newUser.zip"> -->
          <!-- <input type="text" class="form-control m-b-15" placeholder="Address" v-model="newUser.address"> -->
        </div>
        <div class="row">
          <div v-if="numInCart" class="form-control col-md-6">
            <card class="stripe-card" v-bind:class='{ complete }'
              :stripe='stripeKey' v-bind:options='stripeOptions'
              @change='complete = $event.complete' />
          </div>

          <button v-if="numInCart > 0" class='col-sm-4 col-md-6 btn btn-primary pay-with-stripe' @click='pay' :disabled="disabled">Place Your Order</button>
        </div>
      </div>
  </div>
</template>
<script>
import Log from 'loglevel';
import Cart from './Cart.vue';
import Transaction from './Transaction.vue';

import {
  Card,
  CardNumber,
  CardEpxiry,
  CardCvc,
  createToken,
  createSource,
  instance,
} from 'vue-stripe-elements-plus';

export default {
  beforeMount() {
    console.log('stripe: ', instance, Card);
  },
  computed: {
    alertObject: function() {
        if (this.message) {
            return {"alert": true, "alert-info": true, "alert-danger": false};
        } else if (this.message.match('error')) {
            return {"alert": true, "alert-danger": true, "alert-info": false};
        } else {
            return {"alert": false, "alert-info": false, "alert-danger": false};
        }
    },
    message() { return this.msg; },

    numInCart() {
      return this.$store.getters.inCart.length;
    },
    total() {
      return this.$store.getters.inCart.reduce((total, p) => {
        return total + p.price
      }, 0)
    },
  },
  data: function() {
    return {
      disabled: false,

      // stripeKey: process.env.STKEY,
      stripeKey: process.env.STRIPE_PUB || 'pk_test_PQ5TCuMnTBi2A1viAcI47KQe',
      // stripeKey: 'pk_test_6pRNASCoBOKtIshFeQd4XMUh',
      stripeOptions: {
        "placeholder": "Card Number",
        // "name": "aquawiz.net",
        // "zip-code": "false"
        // locale: 'auto',
      },
      complete: false,
      cardData: {
        complete: false,
        number: false,
        expiry: false,
        cvc: false
      },
      newUser: {
        name: "",
        email: "",
        address: "",
        street: "",
        city: "",
        zip: ""
      },
      msg: ""
    };
  },
  components: { Card, Cart },
  methods: {
    setData(data) {
      let passing = {
        id: data.id,
        title: 'Your order number is: ' + data.id,
        lang: this.$route.params["lang"]
      };
      return passing;
    },
    pay() {
      if (this.newUser.name == "" || this.newUser.email == "" ) {
        this.msg = "Please enter all fields.";
        return;
      }
      if (this.complete != true) {
        this.msg = "Please enter card information.";
        return;
      }
      let url = (process.env.SERVER || "aquawizserver-whatsupbro.rhcloud.com");
      let amount = this.total * 100;
      let p1 = createSource({
        type: 'ideal',
        amount: amount,
        currency: 'usd',
        owner: {
          name: this.name
        }
      });

      let p2 = createToken();
      p2.then(data => {
        if (! ('token' in data)) {
          this.message = "Unable to access server";
          return;
        }
        let body = {
          payment: data.token,
          amount: amount,
          user: this.newUser,
          // hack
          // token: data.token.id,
        }
        console.log('token: ', data.token.id, data.token.type, body);
        let p3 = this.$http.post(url + '/api/v1/payment/charge', body);
        let Vue = this;

        p3.then(resp => {
          let data = resp["data"] || {};
          data.amount = body.amount;
          data.user = body.user;
          console.log('payment: ', data);
          let passing = this.setData(data);

          Object.assign(passing, data);
          if (data && data["status"] === "succeeded") {
            this.msg = "Your order number is: " + data["id"];
            this.$store.dispatch('addTrans', data);
          } else {
            Log.debug('status: ', data.status);
            this.msg = "Transaction has failed. Please retry.";
          }
          setTimeout(() => {
            Vue.$store.dispatch('emptyCart', this.newUser);
          }, 1005);
          setTimeout(function() {
            Vue.$router.push({ name: 'transaction', params: passing, props: passing });
          }, 1000);
        }).catch(err => {
          let data = err.data;
          let passing = this.setData(data);
          console.log('payment error: ', err);
          data['title'] = '';
          if (err && err['status'] > 300) {
            let status = err['status'];
            if (status === 415) {
              this.msg = "WARNING: Unable to send email.";
              setTimeout(() => {
                Vue.$store.dispatch('emptyCart', this.newUser);
              }, 1005);
              setTimeout(() => {
                Vue.$router.push({ name: 'transaction', params: passing, props: passing });
              }, 1000);
            } else {
              this.msg = err['data']['message'];
              setTimeout(() => {
                Vue.$router.push({ name: 'cart', params: passing, props: passing });
              }, 2000);
            }
            data['title'] = this.msg;
            this.$store.dispatch('addTrans', data);

          } else {
            this.$store.dispatch('addTrans', data);
            this.msg = "Transaction failed: " + data.message;
          }
        });
      }).catch(err => {
        Log.error('error: ', err);
      });

    }
  },
  destroyed(){
    console.log('destroyed');
  },
  beforeDestroy(){
    console.log('beforeDestroy');
  }
};
</script>
<style>
.stripe-card {
  width: 50%;
  border: 1px solid grey;
}
.stripe-card.complete {
  border-color: green;
}
</style>


// WEBPACK FOOTER //
// Checkout.vue?4d79beb2